export default "__VITE_ASSET__AgoQKHEk__"